import { api } from 'data/api/api'

import { SnadComplaintResp } from '../types/complaint'

export const getSnadComplaint = (transactionId: number) =>
  api.get<SnadComplaintResp>('/complaints/snad', {
    params: { transaction_id: transactionId },
  })
